import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Icon } from "@iconify/react";
import { Fade } from "@mui/material";
import moment from "moment";
import "./Notifications.css";
import CallScheduleDialog from "../CallSchedule/CallScheduleDialog";
import { getContactPhoneApproval } from "../Store/Actions/ContactAction";
import { getListOverdueCallSchedule } from "../Store/Actions/OutboundAction";
import { SET_SELECTED_APPROVAL } from "../Store/Types/AgentTypes";

const Notifications = ({
  isShown,
  changePage,
  setIsNotificationsShown,
  setIsNotificationsBadgeHidden,
}) => {
  const [isCallScheduleDialogShown, setIsCallScheduleDialogShown] =
    useState(false);

  const [listOverdue, setListOverdue] = useState([]);
  const [listApproval, setListApproval] = useState([]);
  const dispatch = useDispatch();
  const { myInfo } = useSelector((state) => state.auth);

  useEffect(() => {
    const fetchData = () => {
      getListOverdueCallSchedule(myInfo.user.AgentID)
        .then((response) => {
          if (response.status) {
            // process.env.NODE_ENV === "development" &&
            //   console.log("List overdue", listOverdue);

            setListOverdue(response.data);
          } else {
            console.log("error", response.error);
          }
        })
        .catch((err) => {
          console.log("err", err);
        });

      // Don't fetch when user is in Notification page
      localStorage.getItem("winPage") !== "notification" &&
        getContactPhoneApproval(myInfo.user.AgentID)
          .then((response) => {
            if (response.status && response.data) {
              // process.env.NODE_ENV === "development" &&
              //   console.log("List approval", response.data.data);

              setListApproval((prevState) => {
                if (response.data.data[1]?.length > prevState?.length) {
                  setIsNotificationsBadgeHidden(false);
                }

                return response.data.data[1];
              });
            } else {
              console.log("error", response.error);
            }
          })
          .catch((err) => {
            console.log("err", err);
          });
    };

    // Fetch data on first render
    fetchData();

    // Fetch data every sixty seconds
    const interval = setInterval(() => {
      fetchData();
    }, 60000);

    return () => clearInterval(interval);
  }, []);

  return (
    <Fade in={isShown} unmountOnExit>
      <div className="notifications">
        <p className="upcoming">
          You have {listApproval ? listApproval.length : 0} Notifications
        </p>

        <div className="notifications-list">
          {listOverdue?.length
            ? listOverdue
                .filter((item) => item !== null)
                .map((item, index) => (
                  <div
                    className="notification-item"
                    key={index}
                    onClick={() => {
                      setIsCallScheduleDialogShown(true);
                    }}
                  >
                    <div className="info">
                      <p className="customer-name">{item.ContactName}</p>
                      <p className="campaign-name">{item.CampaignName}</p>
                    </div>

                    <div className="time">
                      <Icon height="15" icon="ic:round-access-time" />
                      <p>{moment(item.ScheduleTime).format("HH:mm")}</p>
                    </div>
                  </div>
                ))
            : ""}

          {listApproval?.length
            ? listApproval
                .filter((item) => item !== null)
                .map((item, index) => (
                  <div
                    className="notification-item"
                    key={index}
                    onClick={() => {
                      dispatch({
                        type: SET_SELECTED_APPROVAL,
                        payload: item,
                      });

                      setIsNotificationsShown(false);
                      changePage("notification");
                    }}
                  >
                    <div className="info">
                      <p className="customer-name">{item.CreatedBy}</p>

                      <p className="campaign-name">
                        Request Save & Add Contact Info
                      </p>
                    </div>

                    <div className="time">
                      <Icon height="15" icon="ic:round-access-time" />
                      <p>{moment(item.CreatedTime).format("HH:mm")}</p>
                    </div>
                  </div>
                ))
            : ""}
        </div>

        <p
          className="view-all"
          onClick={() => {
            setIsNotificationsShown(false);
            changePage("notification");
          }}
        >
          View All
        </p>

        <CallScheduleDialog
          changePage={changePage}
          isOpen={isCallScheduleDialogShown}
          setIsOpen={setIsCallScheduleDialogShown}
        />
      </div>
    </Fade>
  );
};

export default Notifications;
